import Swal from 'sweetalert2'

export const headersWithAuthWithoutBody = (method, auth) => ({
  method: method,
  headers: auth,
});

export const headersWithAuth = (method, userData, auth) => ({
  method: method,
  headers: auth,
  body: JSON.stringify(userData),
});

export const handleResponse = (response) =>
  response.statusCode === 200
    ? Swal.fire({
      toast: true,
      position: "bottom-end",
      icon: "success",
      title: response.customMessage,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    })
    : Swal.fire({
      toast: true,
      position: "bottom-end",
      icon: 'error',
      text: response.customMessage,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    })

const apiControllers = {};
export function cancelPreviousRequest(apiName) {
  if (apiControllers[apiName]) {
    apiControllers[apiName].abort();
  }
  const controller = new AbortController();
  apiControllers[apiName] = controller;
  return controller.signal;
}